import { render, staticRenderFns } from "./ListRegisterRequests.vue?vue&type=template&id=f85b0012&scoped=true&"
import script from "./ListRegisterRequests.vue?vue&type=script&lang=js&"
export * from "./ListRegisterRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85b0012",
  null
  
)

export default component.exports